import { useState, useEffect } from 'react';
import Backbone from 'backbone';
import Api from 'entities/helpers/api';
import PropTypes from 'prop-types';
import ErrorLogger from 'entities/helpers/error-log-helper';
import EmailDetailHeader from '../components/email-detail-header';
import ScheduledDetailedView from './components/scheduled-detailed-view';

const ScheduledEmailDetailController = ({ id }) => {
  const [scheduledEmail, setScheduledEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getScheduledEmail = async () => {
      try {
        const scheduledEmail = await Api.OUTREACH.EMAIL.get({
          urlArgs: { id },
        });
        setScheduledEmail(scheduledEmail);
      } catch (e) {
        ErrorLogger.error('Error while getting scheduled email', { extra: { e, page_name: 'Outreach Email Detail' } });
        Backbone.history.history.back();
      } finally {
        setLoading(false);
      }
    };
    getScheduledEmail();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <EmailDetailHeader subject={scheduledEmail?.subject} />
      <ScheduledDetailedView email={scheduledEmail} />
    </>
  );
};

ScheduledEmailDetailController.propTypes = {
  id: PropTypes.string,
};

export default ScheduledEmailDetailController;
